import { FC } from 'react';
import CoreScroll from '@nrk/core-scroll/jsx';
import classNames from 'classnames';

import { ReactComponent as ChevronDownSolid } from '@rikstv/play-common/src/icons/svg/chevron-down-strim-solid.svg';
import { isTouchDevice } from '@rikstv/play-common/src/utils/device/device.utils';
import { Dropdown, H4, TertiaryButton } from '@rikstv/shared-components';

import { GenericSeason } from '../../contentStack.types';

import seriesStyles from './GenericSeriesSection.module.css';

type SeasonSelectorProps = {
  seriesData: {
    type: 'sequential' | 'topicality';
    seasons: GenericSeason[];
  };
  selectedSeason: GenericSeason;
  setSelectedSeason: (season: GenericSeason) => void;
};

export const SeasonSelector: FC<SeasonSelectorProps> = ({ seriesData, setSelectedSeason, selectedSeason }) => {
  const isTopicalitySeries = seriesData.type === 'topicality';

  const seasonOptions = seriesData.seasons.map(season => {
    return {
      value: season.link,
      title: isTopicalitySeries ? season.label.toString() : 'Sesong ' + season.label.toString(),
      season: season,
    };
  });

  const displayDropdown =
    (isTopicalitySeries && isTouchDevice) ||
    seriesData.seasons.length >= 10 ||
    (isTouchDevice && seriesData.seasons.length >= 5);

  if (displayDropdown) {
    return (
      <section className={seriesStyles.seasonWrapper}>
        <div className="rds-gutter">
          <Dropdown
            label={<H4 lookLike="title-3"> {isTopicalitySeries ? 'Sendinger' : 'Sesonger'}</H4>}
            id={'season-selector'}
            options={seasonOptions}
            defaultValue={selectedSeason.link}
            onChange={selectedOption => setSelectedSeason(selectedOption.season)}
            rightIcon={<ChevronDownSolid style={{ marginTop: '8px' }} />}
          />
        </div>
      </section>
    );
  }

  return (
    <section className={seriesStyles.seasonWrapper}>
      <div className={classNames('rds-gutter', seriesStyles.seasonScroller)}>
        <H4 lookLike="title-3">{isTopicalitySeries ? 'Sendinger' : 'Sesonger'}</H4>
        <CoreScroll className={seriesStyles.seasonList}>
          {seriesData.seasons.map(season => {
            const selected = season.link === selectedSeason.link;
            return (
              <TertiaryButton
                className={classNames(seriesStyles.seasonButton, selected ? seriesStyles.selectedSeason : '')}
                key={season.link}
                onClick={() => setSelectedSeason(season)}
                disabled={season.episodeCount === 0}>
                <span className="sr-only">Sesong&nbsp;</span>
                {season.label}
              </TertiaryButton>
            );
          })}
        </CoreScroll>
      </div>
    </section>
  );
};
